import React from "react";
import {SpeachToTextIcon} from "@hugeicons/core-free-icons";
import {MiniCard} from "./MiniCard";
import {PeriodMenu} from "./PeriodMenu";
import {ResponseTimeNavigation} from "./ResponseTimeNavigation";
import {useDashboard} from "../../../../context/DashboardContext";
import {formatSeconds, hasActivity, toChartData} from "./response-time-utils";

export const SpeechToTextCard = () => {
  const {responseTime} = useDashboard();
  const statistic = responseTime?.SPEECH_TO_TEXT;
  const chartData = toChartData(statistic);

  return (
    <MiniCard
      icon={SpeachToTextIcon}
      color={"#ff2233"}
      title={formatSeconds(statistic)}
      subtitle={"SPEECH TO TEXT"}
      data={chartData}
      hideChart={!hasActivity(chartData)}
      action={<PeriodMenu type={"SPEECH_TO_TEXT"}/>}
      chartOverlay={<ResponseTimeNavigation type={"SPEECH_TO_TEXT"}/>}
    />
  );
};
